import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import { message } from 'ant-design-vue'
import newTicket from './modules/newTicket.js'

Vue.use(Vuex)

// expire, path, domain, secure, sameSite
VueCookies.config('30d', '', '', true, 'Strict')

export function createStore () {
  return new Vuex.Store({
    modules: {
      newTicket
    },
    // IMPORTANT: state must be a function for SSR
    state: () => ({
      request: {
        param: ''
      },
      issue: {
        title: '',
        project: undefined,
        type: undefined
      },
      jira: {
        jwt: '',
        token: null,
        endpoint: '',
        host: ''
      },
      github: {
        link: ''
      },
      tickets: [
        // { id: 1, key: 'ABC-1', summaryText: 'Very cool ticket', img: 'https://image.flaticon.com/icons/png/128/3889/3889560.png' },
        // { id: 1, key: 'ABC-2', summaryText: 'Very cool ticket 2', img: '', fields: { issuetype: { name: 'Feature' } } },
        // { id: 1, key: 'ABC-3', summaryText: 'Very cool ticket 3', img: ''},
        // { id: 1, key: 'ABC-4', summaryText: 'Very cool ticket 3', img: ''},
        // { id: 1, key: 'ABC-5', summaryText: 'Very cool ticket 3', img: ''}
      ],
      _pendingTicketFetches: []
    }),
    getters: {
      jiraHost: (state) => state.jira.host,
      isJiraSessionActive: (state) => !!state.jira.jwt, // @TODO check expired cookie
      jiraAuthLink: (state) => {
        const authState = state.request.param
        const audience = 'api.atlassian.com'
        const client_id = '6K5i3XPGD2MEX5v05Wwf0xYNiLGF52YM'
        const scope = encodeURIComponent('read:jira-work write:jira-work read:me offline_access')
        const redirect_uri = encodeURIComponent('https://github.quantifyhq.com/connect/auth/jira/callback')

        return `https://auth.atlassian.com/authorize?audience=${audience}&client_id=${client_id}&scope=${scope}&redirect_uri=${redirect_uri}&state=${authState}&response_type=code&prompt=consent`
      },
      prTitle: (state) => state.issue.title
    },
    mutations: {
      tickets: (state, tickets) => state.tickets = tickets.map(e => ({ ...e, linked: false })),
      addTicket: (state, item) => state.tickets.unshift(item),
      updateTicketFields: (state, { key, fields = {} }) => {
        const index = state.tickets.findIndex(e => e.key === key)
        if (index !== -1) {
          state.tickets.splice(index, 1, { ...state.tickets[index], fields })
        }
      },
      toggleTicketLink: (state, key) => {
        const index = state.tickets.findIndex(e => e.key === key)
        if (index !== -1) {
          const linked = !state.tickets[index].linked
          state.tickets.splice(index, 1, { ...state.tickets[index], linked })
        }
      },
      jira: (state, jira) => state.jira = jira
    },
    actions: {
      async pickIssues ({ state, commit, dispatch }, { query = '' } = {}) {
        const currentJQL = encodeURIComponent(`text ~ "${query}" order by updated DESC`)
        return axios.get(`${state.jira.endpoint}/rest/api/3/issue/picker?query=${query}&currentJQL=${currentJQL}`, {
          headers: { Authorization: `Bearer ${state.jira.token}` }
        })
          .then(({ data }) => {
            data.sections.forEach(section => {
              commit('tickets', section.issues)
            })

          // console.log('issue/picker', data)
          })
          .catch((error) => {
            if (error.response.status === 401) {
              return dispatch('refreshJiraToken').then(() => dispatch('pickIssues'))
            }

            return message.error('Can\'t load list of tickets')
          })
      },
      async assignTickets ({ state }, { linked = [] }) {
        await Promise.all(state._pendingTicketFetches)

        const data = linked.map(e => ({
          key: e.key,
          type: e.type,
          link: `${state.jira.host}/browse/${e.key}`
        }))

        return axios.post(`https://github.quantifyhq.com/connect/${state.request.param}/assign`, data)
      },
      fetchTicketFields ({ state, commit }, key) {
        const promise = axios.get(`${state.jira.endpoint}/rest/api/3/issue/${key}`, {
          headers: { Authorization: `Bearer ${state.jira.token}` }
        })
          .then(({ data }) => commit('updateTicketFields', { key, fields: data.fields }))

        state._pendingTicketFetches.push(promise)

        return promise
      },
      initAuthSession ({ getters }) {
        window.location.href = getters.jiraAuthLink
      },
      refreshJiraToken ({ state, commit, dispatch }) {
        // try { localStorage.clear() } catch (err) {}
        return axios.post('https://github.quantifyhq.com/connect/auth/jira/refresh', {}, {
          withCredentials: true
        })
          .then(({ data }) => commit('jira', { ...state.jira, token: data.token }))
          .catch(error => {
            if (error.response.status === 401) dispatch('initAuthSession')
          })
      },
      init ({ state, commit }) {
        console.log('init')

        // Token returned by server
        if (state.jira.token) {
          VueCookies.set('quantify-jwt', state.jira.jwt)
          localStorage.setItem('quantify-github-jira', JSON.stringify(state.jira))
          return
        }

        // Check for local token
        const value = JSON.parse(
          localStorage.getItem('quantify-github-jira') || '""'
        )

        if (!value) return

        commit('jira', value)
      }
    }
    // strict: !config.isProduction,
  })
}
